import React from 'react';

function TasksError() {
  return (
    <p>Error...</p>
  );
}

export { TasksError };